import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";
import * as React from "react";

export function RoundtripColumnMenu(props: GridColumnMenuProps) {
  const data = [{ Roundtrip: "Yes" }, { Roundtrip: "No" }];

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      {...props}
      data={data}
      searchBox={() => null}
    />
  );
}
